/**
 * Idioma da INTERFACE do kanban (não confundir com `customerLanguage`, o idioma
 * do cliente na conversa). Dois idiomas com catálogo: pt-BR e en.
 */
export type UiLocale = 'pt-BR' | 'en';

/** Preferência do operador: `auto` segue `navigator.language`. */
export type UiLocalePreference = 'auto' | UiLocale;

export const UI_LOCALE_PREFERENCES: readonly UiLocalePreference[] = ['auto', 'pt-BR', 'en'];

export function isUiLocalePreference(value: unknown): value is UiLocalePreference {
  return typeof value === 'string' && (UI_LOCALE_PREFERENCES as readonly string[]).includes(value);
}

/**
 * `auto`: `en*` (qualquer região, `_` ou `-`, qualquer caixa) → `en`; o resto
 * (inclusive ausência) → `pt-BR`. Mesmo critério de `resolveGenUiLocale` do
 * genui-kit, sem o ramo `es`. Valor explícito passa direto.
 */
export function resolveUiLocale(
  pref: UiLocalePreference,
  browserLanguage: string | null | undefined,
): UiLocale {
  if (pref !== 'auto') return pref;
  const normalized = browserLanguage?.replaceAll('_', '-').toLowerCase() ?? '';
  return normalized.startsWith('en') ? 'en' : 'pt-BR';
}
